import { IconLibrary } from '@product-framework/index';
import ServiceProviderCompanyInfoEdit from './CompanyInfo/edit';
import ServiceProviderLocation from './Location/index';
import ServiceProviderSkills from './Skills/index';
import SetUp from './SetUp';
import SystemSettings from './SystemSettings/index';
import Performance from './Performance/index';
import Users from './Users/list';
import Availability from './Availability';

const StepperTabsConfig = (
  { userAccess, formatMessage, hasAvailabilityFeature, dispatchPurchased } = {
    dispatchPurchased: false,
  },
) => {
  const tabs = [
    {
      id: 'COMPANYINFO',
      label: formatMessage({
        id: 'COMPANY_INFO',
        defaultMessage: 'Company Info',
      }),
      Component: ServiceProviderCompanyInfoEdit,
      Icon: IconLibrary.CompanyInfo,
      getErrorCount: status =>
        status?.hasServiceTravelDistance === false ? 1 : null,
    },
    {
      id: 'USERS',
      label: formatMessage({
        id: 'USERS',
        defaultMessage: 'Users',
      }),
      Component: Users,
      Icon: IconLibrary.Users,
      statusKey: null,
    },
    {
      id: 'LOCATIONS',
      label: formatMessage({
        id: 'LOCATIONS',
        defaultMessage: 'Locations',
      }),
      Component: ServiceProviderLocation,
      Icon: IconLibrary.ServiceProviderLocations,
      getErrorCount: status => {
        return Array.isArray(status?.hasInvalidLocationAddress) &&
          status?.hasInvalidLocationAddress.length > 0
          ? status?.hasInvalidLocationAddress.length
          : null;
      },
    },
    {
      id: 'SKILLS',
      label: formatMessage({
        id: 'SKILLS',
        defaultMessage: 'Skills',
      }),
      hasPermission: dispatchPurchased,
      Component: ServiceProviderSkills,
      Icon: IconLibrary.Skills,
      getErrorCount: status => {
        return status?.hasSkills === false ? 1 : null;
      },
    },
    {
      id: 'SETUP',
      label: formatMessage({
        id: 'SETUP',
        defaultMessage: 'Setup',
      }),
      Component: SetUp,
      Icon: IconLibrary.Setup,
      getErrorCount: status => {
        let count = 0;
        if (status?.hasNotificationEmail === false) count += 1;
        if (status?.hasInsightCallDefault === false) count += 1;
        if (status?.hasInsightSmsDefault === false) count += 1;
        return count === 0 ? null : count;
      },
    },
    ...(userAccess.isSA() || userAccess.isAdmin()
      ? [
          {
            id: 'SYSTEMSETTINGS',
            label: formatMessage({
              id: 'SYSTEM_SETTINGS',
              defaultMessage: 'System Settings',
            }),
            Component: SystemSettings,
            Icon: IconLibrary.SystemSetting,
            getErrorCount: status => {
              let count = 0;
              if (status?.hasDispatchMethod === false) {
                count += 1;
              }
              if (status?.hasRateCard === false) {
                count += 1;
              }
              if (status?.hasResponsiveIntegration === false) {
                count += 1;
              }
              return count > 0 ? count : null;
            },
          },
        ]
      : []),
    {
      id: 'PERFORMANCE',
      label: formatMessage({
        id: 'PERFORMANCE',
        defaultMessage: 'Performance',
      }),
      Component: Performance,
      Icon: IconLibrary.Performance,
    },
    ...(hasAvailabilityFeature
      ? [
          {
            id: 'AVAILABILITY',
            label: formatMessage({
              id: 'AVAILABILITY',
              defaultMessage: 'Availability',
            }),
            Component: Availability,
            Icon: IconLibrary.AvailabilitySchedular,
          },
        ]
      : []),
  ];
  return tabs.filter(tab => tab.hasPermission !== false);
};

export default StepperTabsConfig;
